import { render, staticRenderFns } from "./InspectionScreen.vue?vue&type=template&id=3ff54d34&scoped=true"
import script from "./InspectionScreen.vue?vue&type=script&lang=js"
export * from "./InspectionScreen.vue?vue&type=script&lang=js"
import style0 from "./InspectionScreen.vue?vue&type=style&index=0&id=3ff54d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff54d34",
  null
  
)

export default component.exports